export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10644.c9d73419.jpg";